
import React from 'react'
import * as R from 'ramda'
import Moment from 'moment'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import {List, ListItem} from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'

import ManagerCard from './ManagerCard'
import { sort } from 'utils/stuff'


export default (o) => (
		<div
			id="main-content"
			style={{
				marginLeft: (typeof global.md.phone() == 'string')?
						"0"
					: '54px'
			  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"5px":"60px"
			  , overflow: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "auto" : 'hidden'
			  , height: "calc(100vh - 60px)"//(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'calc(100vh - 60px)': (typeof global.md.tablet() == "string")? 'calc(100vh - 168px)' : 'calc(100vh - 109px)'
			  , width: (o.rightStackOpened)? (typeof global.md.phone() == 'string')? "100%" : "calc(53% - 62px)" : `calc(100% - ${(typeof global.md.phone() == 'string')? "0px" : "30px"})`
			}}
			onScroll={(evt)=>{
				// if(scrollPos < evt.target.scrollTop){
				// 	if(o.filters) o.toggleFilt()
				// }else if(evt.target.scrollTop < 0){
				// 	console.log("need to open")
				// }
			}}
			speed={0.8}
			className="area"
			contentClassName="content"
			horizontal={false}
			verticalScrollbarStyle={{
				width: "20px"
			  , borderRadius: "13px"
			  , marginLeft: "3px"
			  , backgroundImage: "url(/assets/manager/img/bar.png)"
			  , backgroundSize: "100%"
			  , backgroundRepeat: "no-repeat"
			  , backgroundColor: "#f5f6f5"
			  , backgroundPosition: "center"
			  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
			}}
			minScrollSize={"50"}
			verticalContainerStyle={{
				width: "26px"
			  , backgroundColor: "#cdcdcd"
			  , opacity: "1 !important"
			  , display: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "none" :"auto"
			}}
		>
		{(typeof global.md.phone() != 'string')?
			<div
				style={{
					fontSize: "20px"
				  , marginTop: "31px"
				  , color: "#FFF"
				  , position: "fixed"
				  , zIndex: "1000"
				  , top: "-15px"
				  , left: "76px"
				}}
			>
				Managers
			</div>
			: ""
		}
		<List
			style={{
				backgroundColor: "transparent"
			}}
		>
			{(R.keys(o.managers).length)?
				R.map((manager) => (
					<ManagerCard
						key={`project-${manager._id}`}
						manager={manager}
						id={manager._id}
						openPanel={o.openPanel}
						lastInteracted={o.lastInteracted}
					/>
			),  sort(o.managers, "name"))
				: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No managers</p>
			}
		</List>
	</div>
)
/*{()=> {

}}*/



// WEBPACK FOOTER //
// ./src/routes/manager/managers/ManagersList.js